import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import { FastField } from 'formik';
import { inputStyle } from './BaseInput';

const DateInput = ({label, name, helperText, required=true, disableFuture=true}) => {
   
    return (
        <FastField name={name}>
            {({meta, form }) => {

                const isInValid = meta.error && meta.touched;

                const setDate = (value) => {
                    // using moment js
                    const dateValue = value ? value?.format("YYYY-MM-DD") : null;
                    form.setFieldValue(name, dateValue);
                };

                return (
                    <DatePicker
                        disableFuture={disableFuture}
                        label={label}
                        openTo="year"
                        views={['year', 'month', 'day']}
                        value={meta.value}
                        onChange={setDate} 
                        renderInput={(params) => (
                            <TextField 
                                {...params}
                                required={required}
                                error={isInValid}
                                helperText={isInValid ? meta.error : helperText}
                                variant="outlined"
                                fullWidth
                                sx={inputStyle}
                            />
                        )}
                    />
                );
            }}
        </FastField>
    );
};
    
export default DateInput;